

export const getConstants = (businessValue:string = "coppel-hdi") => {
  /* const business = "coppel-hdi";*/
  const business = businessValue;
  return { business };
};